/**
 * File: off-canvas.js
 *
 * Help deal with the off-canvas mobile menu.
 */

// Make sure everything is loaded first.
if (
	( 'complete' === document.readyState ||
		'loading' !== document.readyState ) &&
	! document.documentElement.doScroll
) {
	wdsOffCanvas();
} else {
	document.addEventListener( 'DOMContentLoaded', wdsOffCanvas );
}

/**
 * Kick off our off canvas functions.
 *
 * @author Corey Collins
 * @since January 31, 2020
 */
function wdsOffCanvas() {
	const menuButton = document.querySelector( '#menu-button' );
	const loginButton = document.querySelector( '#login-button' );
	const offCanvasMenu = document.querySelector( '#off-canvas-menu' );
	const offCanvasLogin = document.querySelector( '#off-canvas-login' );

	if ( menuButton && offCanvasMenu ) {
		menuButton.addEventListener( 'click', function () {
			toggleOffCanvas( offCanvasMenu, menuButton );
		} );
	}

	if ( loginButton && offCanvasLogin ) {
		loginButton.addEventListener( 'click', function () {
			toggleOffCanvas( offCanvasLogin, loginButton );
		} );
	}

	document.body.addEventListener( 'keydown', function ( event ) {
		if ( event.keyCode === 27 ) {
			// ESC key
			closeOffCanvas( offCanvasMenu, menuButton );
			closeOffCanvas( offCanvasLogin, loginButton );
		}
	} );

	function toggleOffCanvas( offCanvasElement, buttonElement ) {
		if ( offCanvasElement.classList.contains( 'is-visible' ) ) {
			closeOffCanvas( offCanvasElement, buttonElement );
		} else {
			openOffCanvas( offCanvasElement, buttonElement );
		}
	}

	function closeOffCanvas( offCanvasElement, buttonElement ) {
		offCanvasElement.classList.remove( 'is-visible' );
		buttonElement.classList.remove( 'is-visible' );
		offCanvasElement.setAttribute( 'aria-hidden', true );
		buttonElement.setAttribute( 'aria-expanded', false );
	}

	function openOffCanvas( offCanvasElement, buttonElement ) {
		offCanvasElement.classList.add( 'is-visible' );
		buttonElement.classList.add( 'is-visible' );
		offCanvasElement.setAttribute( 'aria-hidden', false );
		buttonElement.setAttribute( 'aria-expanded', true );
	}
}

// Ensure that the script runs after the DOM is fully loaded.
if ( document.readyState === 'complete' || document.readyState !== 'loading' ) {
	wdsOffCanvas();
} else {
	document.addEventListener( 'DOMContentLoaded', wdsOffCanvas );
}
